import { render, staticRenderFns } from "./DLGEditor.vue?vue&type=template&id=3c0004ed&"
import script from "./DLGEditor.vue?vue&type=script&lang=js&"
export * from "./DLGEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports